import React, { useState, useContext } from 'react';
import { Modal, Link } from '@shopify/polaris'
import { Spinner } from '@thinkwell/react.polaris'
import { HostContext } from '../../contexts/Host'
import { ShopContext } from '../../contexts/Shop'
import Iframe from 'react-iframe'
import { isSafari } from 'react-device-detect';

export default function QuickViewModal(props) {
  const [active, setActive] = useState(false)
  const [loading, setLoading] = useState(false)
  const host = useContext(HostContext)
  const shop_name = useContext(ShopContext)

  const handleChange = () => { setLoading(true); setActive(!active) }

  const url = `${host}/accounts/goto_course?enrollment_id=${props.enrollmentId}&shop_name=${shop_name}&quick_view_id=${props.quickView.id}`

  // shopper#677 : open in new tab on safari
  const activator = <Link external={isSafari} url={isSafari ? url : null} onClick={!isSafari ? handleChange : null}>{props.linkTitle || props.quickView.title}</Link>;

  return (<div>
    <Modal
      title={props.title || props.linkTitle || props.quickView.title}
      activator={activator}
      open={active}
      onClose={handleChange}
      large={!props.quickView.isSmall}
      secondaryActions={[{
        content: 'Close',
        onAction: handleChange
      }]}
    >
    <Modal.Section>
      <div className={`quick-view-modal quick-view-modal-${props.quickView.size}`} >
      { loading ? <div className="loader" /> : <div /> }
      <Iframe
      url={url}
      width="100%"
      height="100%"
      onLoad={() => setLoading(false)}
      />
      </div>
    </Modal.Section>
  </Modal>
  </div>)
}
